var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ModalContent', {
    attrs: {
      "flat-chrome": "",
      "help-content-id": "popup-provider-".concat(_vm.current_entity_profile)
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('template', {
    slot: "content"
  }, [_c('div', {
    staticClass: "stitch-modal general-settings-reference stitch-form"
  }, [_vm.isExternal ? _c('Warning', {
    staticClass: "mb-2",
    attrs: {
      "elevation": 2
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("instructionsExternal")) + " ")]) : _vm._e(), _c('v-card', {
    staticClass: "stitch-modal__card provider-configuration-card",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', [_c('h5', {
    staticClass: "stitch-modal__title"
  }, [_c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-domain")]), _c('span', [_vm._v(_vm._s(_vm.$translate("providerConfiguration")))])], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('CompanySearchAutocomplete', {
    attrs: {
      "error-messages": _vm.provider_saving_errors.name,
      "label": _vm.$translate('labels.name'),
      "placeholder": _vm.$translate('placeholders.companyName'),
      "dense": true,
      "outlined": "",
      "autofocus": true
    },
    on: {
      "company-selected": _vm.onCompanySelected,
      "keydown": _vm.handleKeyPress
    },
    model: {
      value: _vm.provider.name,
      callback: function callback($$v) {
        _vm.$set(_vm.provider, "name", $$v);
      },
      expression: "provider.name"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('CompanySearchAutocomplete', {
    attrs: {
      "value": _vm.provider.legal_name,
      "error-messages": _vm.provider_saving_errors.legal_name,
      "label": _vm.$translate('labels.legal_name'),
      "placeholder": _vm.$translate('placeholders.legal_name'),
      "dense": true,
      "outlined": ""
    },
    on: {
      "input": _vm.onLegalNameInput,
      "company-selected": _vm.onLegalNameCompanySelected,
      "keydown": _vm.handleKeyPress
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.provider_saving_errors.code,
      "label": _vm.$translate('labels.code'),
      "placeholder": _vm.$translate('codePlaceholder'),
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "name": "code"
    },
    on: {
      "keydown": _vm.handleKeyPress
    },
    model: {
      value: _vm.provider.code,
      callback: function callback($$v) {
        _vm.$set(_vm.provider, "code", $$v);
      },
      expression: "provider.code"
    }
  })], 1), !_vm.isExternal ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.provider_saving_errors.upc_prefix,
      "label": _vm.$translate('labels.upc_prefix'),
      "placeholder": _vm.$translate('placeholders.upc_prefix'),
      "dense": "",
      "outlined": "",
      "hide-details": "auto"
    },
    on: {
      "keydown": _vm.handleKeyPress
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', [_vm._v(_vm._s(_vm.$translate("labels.upc_prefix"))), _c('StitchHint', {
          attrs: {
            "hint": _vm.$translate('hints.upc_prefix')
          }
        })], 1)];
      },
      proxy: true
    }], null, false, 2937041057),
    model: {
      value: _vm.provider.upc_prefix,
      callback: function callback($$v) {
        _vm.$set(_vm.provider, "upc_prefix", $$v);
      },
      expression: "provider.upc_prefix"
    }
  })], 1) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('CompanySiren', {
    attrs: {
      "error-messages": _vm.provider_saving_errors.siren,
      "label": _vm.$translate('labels.siren'),
      "placeholder": _vm.$translate('placeholders.siren'),
      "dense": true,
      "outlined": ""
    },
    on: {
      "company-selected": _vm.onCompanySelected,
      "keydown": _vm.handleKeyPress
    },
    model: {
      value: _vm.provider.siren,
      callback: function callback($$v) {
        _vm.$set(_vm.provider, "siren", $$v);
      },
      expression: "provider.siren"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.provider_saving_errors.vat_number,
      "label": _vm.$translate('labels.vat_number'),
      "dense": "",
      "outlined": "",
      "hide-details": "auto"
    },
    on: {
      "keydown": _vm.handleKeyPress
    },
    model: {
      value: _vm.provider.vat_number,
      callback: function callback($$v) {
        _vm.$set(_vm.provider, "vat_number", $$v);
      },
      expression: "provider.vat_number"
    }
  })], 1), !_vm.isExternal ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.provider.vat_rate ? _vm.decimal(_vm.provider.vat_rate).times(100) : null,
      "error-messages": _vm.provider_saving_errors.vat_rate,
      "label": _vm.$translate('labels.vat_rate'),
      "disabled": _vm.isExternal,
      "dense": "",
      "outlined": "",
      "hide-details": "auto"
    },
    on: {
      "input": function input($event) {
        _vm.provider.vat_rate = $event ? _vm.decimal($event).dividedBy(100) : null;
      },
      "keydown": _vm.handleKeyPress
    }
  })], 1) : _vm._e(), !_vm.provider.entity ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "disabled": _vm.isExternal,
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "items": [{
        text: _vm.$translate('labels.prices_exclude_vat'),
        value: false
      }, {
        text: _vm.$translate('labels.prices_include_vat'),
        value: true
      }],
      "label": _vm.$translate('labels.vat')
    },
    on: {
      "keydown": _vm.handleKeyPress
    },
    model: {
      value: _vm.provider.prices_include_vat,
      callback: function callback($$v) {
        _vm.$set(_vm.provider, "prices_include_vat", $$v);
      },
      expression: "provider.prices_include_vat"
    }
  })], 1) : _vm._e(), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('AddressForm', {
    attrs: {
      "title": _vm.$translate('labels.address'),
      "value": _vm.provider.address || {},
      "errors": _vm.provider_saving_errors.address,
      "dense": true,
      "outlined": ""
    },
    on: {
      "input": function input($event) {
        _vm.provider.address = $event;
      },
      "keydown": _vm.handleKeyPress
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mb-4"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('TagInput', {
    attrs: {
      "object-type": "provider",
      "label": _vm.$translate('labels.tags'),
      "placeholder": _vm.$translate('placeholders.tags'),
      "dense": true,
      "outlined": "",
      "hide-details": "auto"
    },
    on: {
      "keydown": _vm.handleKeyPress
    },
    model: {
      value: _vm.provider.tags,
      callback: function callback($$v) {
        _vm.$set(_vm.provider, "tags", $$v);
      },
      expression: "provider.tags"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "error-messages": _vm.provider_saving_errors.comments,
      "label": _vm.$translate('labels.comments'),
      "placeholder": _vm.$translate('placeholders.comments'),
      "dense": "",
      "outlined": "",
      "hide-details": "auto"
    },
    on: {
      "keydown": _vm.handleKeyPress
    },
    model: {
      value: _vm.provider.comments,
      callback: function callback($$v) {
        _vm.$set(_vm.provider, "comments", $$v);
      },
      expression: "provider.comments"
    }
  })], 1)], 1)], 1)], 1), _c('v-card', {
    staticClass: "stitch-modal__card",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', [_c('h5', {
    staticClass: "stitch-modal__title"
  }, [_c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-credit-card-outline")]), _c('span', [_vm._v(_vm._s(_vm.$translate("paymentMethodSection")))])], 1), _c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.paymentMethodChoices,
      "label": _vm.$translate('labels.preferredPaymentMethod'),
      "error-messages": _vm.provider_saving_errors.preferred_payment_method,
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "clearable": ""
    },
    model: {
      value: _vm.provider.preferred_payment_method,
      callback: function callback($$v) {
        _vm.$set(_vm.provider, "preferred_payment_method", $$v);
      },
      expression: "provider.preferred_payment_method"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.provider_saving_errors.payee_iban,
      "label": _vm.$translate('labels.payeeIban'),
      "dense": "",
      "outlined": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.provider.payee_iban,
      callback: function callback($$v) {
        _vm.$set(_vm.provider, "payee_iban", $$v);
      },
      expression: "provider.payee_iban"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.provider_saving_errors.payee_bic,
      "label": _vm.$translate('labels.payeeBic'),
      "dense": "",
      "outlined": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.provider.payee_bic,
      callback: function callback($$v) {
        _vm.$set(_vm.provider, "payee_bic", $$v);
      },
      expression: "provider.payee_bic"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.provider_saving_errors.payee_account_holder,
      "label": _vm.$translate('labels.payeeAccountHolder'),
      "dense": "",
      "outlined": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.provider.payee_account_holder,
      callback: function callback($$v) {
        _vm.$set(_vm.provider, "payee_account_holder", $$v);
      },
      expression: "provider.payee_account_holder"
    }
  })], 1)], 1)], 1)], 1)], 1)]), _c('template', {
    slot: "bottom"
  }, [_c('Button', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto",
    attrs: {
      "text": _vm.$translate('buttons.cancel'),
      "ghost": ""
    },
    on: {
      "click": _vm.cancelEditClicked
    }
  }), _c('Button', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto ml-sm-3",
    attrs: {
      "text": _vm.saveText,
      "disabled": _vm.canSave || _vm.provider_saving,
      "loading": _vm.provider_saving
    },
    on: {
      "click": _vm.saveInformationClicked
    }
  })], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }